import { render, staticRenderFns } from "./google-search-settings.vue?vue&type=template&id=26454c7b&scoped=true"
import script from "./google-search-settings.vue?vue&type=script&lang=js"
export * from "./google-search-settings.vue?vue&type=script&lang=js"
import style0 from "./google-search-settings.vue?vue&type=style&index=0&id=26454c7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26454c7b",
  null
  
)

export default component.exports